import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'optionLabel'
})
export class OptionLabelPipe implements PipeTransform {

  transform(
    opt: { name: string; alternateName?: string } | null,
    displayAlternate: boolean
  ): string {
    if (!opt) return '';

    if (displayAlternate && opt.alternateName) {
      return `${opt.name} (${opt.alternateName})`;
    }

    return opt.name ?? '';
  }

}
